import './_totals.scss';
import './_totals.dark-mode.scss';
import React, { useState } from 'react';
import { Button, Fade } from 'react-bootstrap';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Totals = ({ styles, headContent, content }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="totals" style={styles}>
      <div
        className={classNames('totals__border totals__border-left', {
          hidden: show,
        })}
      />
      <div className="totals__content">
        <Button bsStyle="link" onClick={() => setShow(true)}>
          Show totals
        </Button>
      </div>
      <div
        className={classNames('totals__border totals__border-right', {
          hidden: show,
        })}
      />

      <RootCloseWrapper disabled={!show} onRootClose={() => setShow(false)} event="click">
        <Fade in={show} unmountOnExit>
          <div className="totals__popover">
            <div className="totals__popover-head">
              <Button bsStyle="link" onClick={() => setShow(false)}>
                Hide totals
              </Button>
              {typeof headContent === 'function' ? headContent({ show }) : headContent}
            </div>
            <div className="totals__popover-body">{typeof content === 'function' ? content({ show }) : content}</div>
          </div>
        </Fade>
      </RootCloseWrapper>
    </div>
  );
};

Totals.propTypes = {
  styles: PropTypes.object,
  headContent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
};

export default Totals;
